import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedParagraph } from '@mews-commander/ui';
import { MainSectionLayout } from '../../components/Layouts/MainSectionLayout';
import { LocalizedSectionTitleLarge } from '../../components/Typography';
import { NonEligibleRequirementsList } from './NonEligibleRequirementsList';

export const NonEligibleUsers = () => (
    <MainSectionLayout isFullHeight>
        <Stack vertical spacing="300">
            <LocalizedSectionTitleLarge textKey={TextKey.FinancialServicesCapitalHeaderNonEligible} />
            <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalSubheaderNonEligible} />
            <NonEligibleRequirementsList />
        </Stack>
    </MainSectionLayout>
);
